export const EVENTS = {
    VALENTINES: "valentines",
    WOMENS_DAY: "womens_day",
    EASTER: "easter",
};

export const EVENTS_DICTIONARY = {
    [EVENTS.VALENTINES]: "Valentines",
    [EVENTS.WOMENS_DAY]: "Women's day",
    [EVENTS.EASTER]: "Easter",
};
